module.exports = __webpack_public_path__ + "img/01tab-all.e8187b26.png";